<template>

    <div class="view-action-list">

        <cms-heading title="Actielijst" level="2">
            <cms-dropdown placeholder="Status wijzigen (max. 25 acties)..." :options="stateOptions" @input="updateState" style="min-width: 250px;"></cms-dropdown>
            <cms-button v-if="isAdminOrAdvisor" icon="magicon-jump-right-up" @click="exportActions()">Exporteer acties</cms-button>
        </cms-heading>

        <cms-table-panel v-spinner="loading" :item-count="actions.totalCount || 0" :items-per-page="itemsPerPage" :offset="offset" @page="offset = arguments[0]" :placeholder="!actions.items || !actions.items.length" clickable="true">
            <cms-table-header>
                <cms-th field="loggerId" v-model="sort">Logger</cms-th>
                <cms-th>Type</cms-th>
                <cms-th field="projectId" v-model="sort">Project</cms-th>
                <cms-th field="locationTitle" v-model="sort">Locatie WWD</cms-th>
                <cms-th field="measuringPoint" v-model="sort">Meetpunt</cms-th>
                <cms-th field="issueDate" v-model="sort">Datum van probleem</cms-th>
                <cms-th field="deadline" v-model="sort">Deadline</cms-th>
                <cms-th field="state" v-model="sort">Status</cms-th>
                <cms-th field="categories" v-model="sort">Categorie&euml;n kantoor</cms-th>
                <cms-th field="commentsOffice" v-model="sort">Opm. kantoor</cms-th>
                <cms-th field="categoriesField" v-model="sort" v-if="isAdminOrAdvisor">Categorie&euml;n veld</cms-th>
                <cms-th field="commentsField" v-model="sort" v-if="isAdminOrAdvisor">Opm. veld</cms-th>
                <cms-th></cms-th>
            </cms-table-header>
            <tr v-for="action in actions.items" @click="showAction(action)">
                <td><router-link :to="{ name: 'action-view', params: { id: action.id } }" @click.stop>{{ action.logger.serialNumber }}</router-link></td>
                <td>{{ action.logger.type.title }}</td>
                <td>{{ action.project.code }}</td>
                <td>{{ action.locationTitle | empty }}</td>
                <td>{{ action.measuringPoint }}</td>
                <td>{{ action.issueDate | date('LL') }}</td>
                <td>{{ action.deadline | actionDeadlineDate(action.issueDate) | date('LL') }}</td>
                <td><cms-text-label :title="action.state | actionState" :color="action.state | actionStateColor" /></td>
                <td>{{ parseCategories(action.categories) }}</td>
                <td>{{ action.commentsOffice }}</td>
                <td v-if="isAdminOrAdvisor">{{ parseCategories(action.categoriesField) }}</td>
                <td v-if="isAdminOrAdvisor">{{ action.commentsField }}</td>
                <td class="actions" @click.stop>
                    <router-link :to="{ name: 'action-view', params: { id: action.id } }" v-tooltip="'Bekijken'"><i class="entypo-eye"></i></router-link>
                    <router-link :to="{ name: 'action-edit', params: { id: action.id } }" v-tooltip="'Wijzigen'"><i class="magicon-edit"></i></router-link>
                </td>
            </tr>
        </cms-table-panel>

    </div>

</template>

<script>

    import Component from 'vue-class-component'
    import Vue from 'global-vue'

    import ActionQueries from 'app/queries/ActionQueries'

    import actionCategoryFilter from 'app/filters/actionCategory'

    import UserRole from 'app/enums/UserRole'
    import ActionState from 'app/enums/ActionState'

    @Component({

        name: 'actions-list',
        props: ['filter'],
        apollo: {

            actions: ActionQueries.all({

                fetchPolicy: 'cache-and-network',
                variables(){

                    return {

                        offset: this.offset,
                        limit: this.itemsPerPage,
                        filter: this.filter,
                        sortField: this.sort.field,
                        sortDirection: this.sort.direction
                    }
                }
            })
        }
    })
    export default class ActionsList extends Vue
    {
        static SORT_STORAGE_KEY = "ActionsSort";
        static OFFSET_STORAGE_KEY = "ActionsOffset";

        data(){

            return {

                actions: {},
                loading: 0,

                offset: parseInt(this.$storage.getSession(ActionsList.OFFSET_STORAGE_KEY, 0)),
                itemsPerPage: 20,
                sort: this.$storage.getSession(ActionsList.SORT_STORAGE_KEY, {
                    field: 'issueDate',
                    direction: 'DESC'
                })
            }
        }

        created(){
            
            this.$watch('sort', (sort) => this.$storage.setSession(ActionsList.SORT_STORAGE_KEY, sort));
            this.$watch('offset', (offset) => this.$storage.setSession(ActionsList.OFFSET_STORAGE_KEY, offset));

            this.$watch('filter', () => this.offset = 0);
        }

        refetch(){

            this.refetchQuery('actions');
        }

        onQueryError(error){

            this.$logger.error(error);
            this.$toast.error('De gegevens konden niet worden opgehaald');
        }

        get isAdminOrAdvisor(){

            return [UserRole.ADVISOR, UserRole.ADMIN].indexOf(this.$user.role) >= 0;
        }

        parseCategories(categories){

            const formattedCategories = categories.map(actionCategoryFilter);
            return formattedCategories.join(', ');
        }

        showAction(action){

            this.$router.push({

                name: 'action-view',
                params: { id: action.id }
            });
        }

        exportActions(){

            let queryParams = [];

            queryParams.push('sortField=' + this.sort.field);
            queryParams.push('sortDirection=' + this.sort.direction);
            queryParams.push('filter=' + JSON.stringify(this.filter));

            window.open(this.$config.apiUrl + '/export/csv/actions?' + encodeURI(queryParams.join('&')));
        }

        updateState(state){

            this.$emit('update-state', {
                state,
                filter: this.filter,
                actionCount: this.actions.totalCount,
                sortField: this.sort.field,
                sortDirection: this.sort.direction
            });
        }

        get stateOptions(){

            return ActionState.options();
        }
    }

</script>